import {
  Card,
  DiffViewerContentCols,
  DiffViewerTitleCols,
  Row,
} from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import type { InspectionEvaluationSsModel } from '../../../_models/project';

type InspectionEvaluation = z.infer<typeof InspectionEvaluationSsModel>;
type PartialInspectionEvaluationModel = Partial<InspectionEvaluation>;
type InspectionAndImprovementByAdministrativeJurisdictionModel =
  InspectionEvaluation['inspectionAndImprovementByAdministrativeJurisdiction'];

type Props = {
  sourceInspectionEvaluation: PartialInspectionEvaluationModel; // left side
  targetInspectionEvaluation: PartialInspectionEvaluationModel; // right side
};

export const SsInspectionEvaluationDiffView: FC<Props> = ({
  sourceInspectionEvaluation,
  targetInspectionEvaluation,
}) => {
  const { t } = useTranslation();

  const inspectionAndImprovementByAdministrativeJurisdictionLegendMap: Array<{
    key: keyof InspectionAndImprovementByAdministrativeJurisdictionModel;
    legend: string;
  }> = [
    { key: 'inspectionResult', legend: t('inspection-result') },
    { key: 'evaluation', legend: t('evaluation') },
    { key: 'directionOfImprovement', legend: t('direction-of-improvement') },
  ];

  return (
    <Card>
      <Row gutter={[8, 0]}>
        <DiffViewerTitleCols
          label={t(
            'inspection-and-improvement-by-iaa-administrative-jurisdiction',
          )}
        />
        {inspectionAndImprovementByAdministrativeJurisdictionLegendMap.map(
          ({ key, legend }) => (
            <DiffViewerContentCols<InspectionAndImprovementByAdministrativeJurisdictionModel>
              key={key}
              legend={legend}
              prop={key}
              isLongField
              showLegendAnytime={{ source: true, target: true }}
              source={
                sourceInspectionEvaluation.inspectionAndImprovementByAdministrativeJurisdiction
              }
              target={
                targetInspectionEvaluation.inspectionAndImprovementByAdministrativeJurisdiction
              }
            />
          ),
        )}
      </Row>
    </Card>
  );
};
